import { render, staticRenderFns } from "./TableElements.vue?vue&type=template&id=549b480b&scoped=true&"
import script from "./TableElements.vue?vue&type=script&lang=js&"
export * from "./TableElements.vue?vue&type=script&lang=js&"
import style0 from "./TableElements.vue?vue&type=style&index=0&id=549b480b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549b480b",
  null
  
)

export default component.exports